import React from 'react';
import { toFormikValidationSchema } from 'zod-formik-adapter';

import { FormBodyAPI } from 'src/constants';
import { ProductStoreEditor } from 'src/routes/billing/store/components/ProductStoreEditor';
import { productStoreSchema } from 'src/routes/billing/store/schema';

const FormRenderer: React.FC<FormBodyAPI> = (props) => {
  return <ProductStoreEditor {...props} />;
};

export const useProductStoreForm = () => {
  return {
    FormRenderer,
    validationScheme: toFormikValidationSchema(productStoreSchema),
  };
};
